import { Directive, ElementRef, inject, input, OnInit } from "@angular/core";
import { VdsDialog } from "./dialog";
import { getClosestDialog } from "./dialog-utils";
import { closeDialogVia, VdsDialogRef } from "./dialog-ref";

@Directive({
    selector: "[vdsDialogClose]",
    exportAs: "vdsDialogClose",
    host: {
        "(click)": "_onButtonClick($event)",
        "[attr.aria-label]": "ariaLabel() || null",
        "[attr.type]": "type()"
    }
})
export class VdsDialogCloseDirective implements OnInit {
    private dialogRef = inject<VdsDialogRef<any>>(VdsDialogRef, { optional: true });
    private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private dialog = inject(VdsDialog);

    readonly ariaLabel = input<string>();

    readonly type = input<"submit" | "button" | "reset">("button");

    readonly dialogResult = input<any>(undefined, { alias: "vdsDialogClose" });

    ngOnInit(): void {
        if (!this.dialogRef) {
            this.dialogRef = getClosestDialog(this.elementRef, this.dialog.openDialogs)!;
        }
    }

    _onButtonClick(event: MouseEvent): void {
        // Determinate the focus origin using the click event, because using the FocusMonitor will
        // result in incorrect origins. Most of the time, close buttons will be auto focused in the
        // dialog, and therefore clicking the button won't result in a focus change. This means that
        // the FocusMonitor won't detect any origin change, and will always output `program`.
        closeDialogVia(this.dialogRef!, event.screenX === 0 && event.screenY === 0 ? "keyboard" : "mouse", this.dialogResult());
    }
}
